/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AssignProgramCommand } from '../model/assignProgramCommand';
import { AssignWorkoutCommand } from '../model/assignWorkoutCommand';
import { AssignWorkoutCommandResult } from '../model/assignWorkoutCommandResult';
import { DeleteUserWorkoutActivityCommand } from '../model/deleteUserWorkoutActivityCommand';
import { GetSingleUserScheduleDayQueryResult } from '../model/getSingleUserScheduleDayQueryResult';
import { GetUserScheduleQueryResult } from '../model/getUserScheduleQueryResult';
import { GetUserWorkoutCommentsQueryResult } from '../model/getUserWorkoutCommentsQueryResult';
import { GetUserWorkoutDetailsQueryResult } from '../model/getUserWorkoutDetailsQueryResult';
import { GetUserWorkoutForChatPortalQueryResult } from '../model/getUserWorkoutForChatPortalQueryResult';
import { GetUserWorkoutForChatQueryResult } from '../model/getUserWorkoutForChatQueryResult';
import { GetUserWorkoutLastSubmittedQueryResult } from '../model/getUserWorkoutLastSubmittedQueryResult';
import { GetUserWorkoutQueryResult } from '../model/getUserWorkoutQueryResult';
import { GetUserWorkoutSubmissionsForCalendarQueryResult } from '../model/getUserWorkoutSubmissionsForCalendarQueryResult';
import { GetUserWorkoutsForCalendarQueryResult } from '../model/getUserWorkoutsForCalendarQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { StartCoachTrackingCommandResult } from '../model/startCoachTrackingCommandResult';
import { SubmitWorkoutCommand } from '../model/submitWorkoutCommand';
import { UnsubmitWorkoutCommandResult } from '../model/unsubmitWorkoutCommandResult';
import { UpdateUserScheduleCommand } from '../model/updateUserScheduleCommand';
import { UpdateUserWorkoutActivityAttributesCommand } from '../model/updateUserWorkoutActivityAttributesCommand';
import { UpdateUserWorkoutActivityOrdinalsCommand } from '../model/updateUserWorkoutActivityOrdinalsCommand';
import { UpdateUserWorkoutCommand } from '../model/updateUserWorkoutCommand';
import { UpdateWorkoutStatusesCommand } from '../model/updateWorkoutStatusesCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserWorkoutsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Assigns workout to user
     * Assigns a workout to the current user&#x27;s schedule
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'body', reportProgress?: boolean): Observable<AssignWorkoutCommandResult>;
    public meUserWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssignWorkoutCommandResult>>;
    public meUserWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssignWorkoutCommandResult>>;
    public meUserWorkoutsAssignPost(body?: AssignWorkoutCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AssignWorkoutCommandResult>('post',`${this.basePath}/Me/UserWorkouts/Assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets workout submission for a day
     * Returns the user&#x27;s workout submission details for a specific day
     * @param assignedDateLocal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsDateGet(assignedDateLocal?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutsForCalendarQueryResult>;
    public meUserWorkoutsDateGet(assignedDateLocal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutsForCalendarQueryResult>>;
    public meUserWorkoutsDateGet(assignedDateLocal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutsForCalendarQueryResult>>;
    public meUserWorkoutsDateGet(assignedDateLocal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (assignedDateLocal !== undefined && assignedDateLocal !== null) {
            queryParameters = queryParameters.set('AssignedDateLocal', <any>assignedDateLocal);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutsForCalendarQueryResult>('get',`${this.basePath}/Me/UserWorkouts/Date`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets user workout schedule
     * Returns the user&#x27;s workout program days/schedule for a specified period
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserScheduleQueryResult>;
    public meUserWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserScheduleQueryResult>>;
    public meUserWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserScheduleQueryResult>>;
    public meUserWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserScheduleQueryResult>('get',`${this.basePath}/Me/UserWorkouts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Submits workout completion
     * Changes workout status and creates comments on selected exercises
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Me/UserWorkouts/Submit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets user workout day details
     * Returns chat workout details for the specified user workout UID
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidChatGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutForChatQueryResult>;
    public meUserWorkoutsUidChatGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutForChatQueryResult>>;
    public meUserWorkoutsUidChatGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutForChatQueryResult>>;
    public meUserWorkoutsUidChatGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidChatGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutForChatQueryResult>('get',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}/Chat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets workout comments
     * Returns comments for all user workouts sharing the same workout type
     * @param uid 
     * @param isDailyWorkout 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidCommentsGet(uid: string, isDailyWorkout?: boolean, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutCommentsQueryResult>;
    public meUserWorkoutsUidCommentsGet(uid: string, isDailyWorkout?: boolean, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutCommentsQueryResult>>;
    public meUserWorkoutsUidCommentsGet(uid: string, isDailyWorkout?: boolean, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutCommentsQueryResult>>;
    public meUserWorkoutsUidCommentsGet(uid: string, isDailyWorkout?: boolean, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidCommentsGet.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isDailyWorkout !== undefined && isDailyWorkout !== null) {
            queryParameters = queryParameters.set('isDailyWorkout', <any>isDailyWorkout);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutCommentsQueryResult>('get',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}/Comments`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Deletes assigned user workout
     * Removes the assigned workout from the user&#x27;s schedule
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserWorkoutsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserWorkoutsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserWorkoutsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Removes a coach-assigned workout from the client&#x27;s plan
     * Marks a Pending coach-assigned workout as dismissed; the coach can restore it
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidDismissPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserWorkoutsUidDismissPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserWorkoutsUidDismissPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserWorkoutsUidDismissPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidDismissPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}/Dismiss`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets personal workout
     * Returns the user&#x27;s workout
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutQueryResult>;
    public meUserWorkoutsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutQueryResult>>;
    public meUserWorkoutsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutQueryResult>>;
    public meUserWorkoutsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutQueryResult>('get',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets last submitted workout
     * Returns the last submitted workout metadata (by assigned date) for the same workout type
     * @param uid 
     * @param isDailyWorkout 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidLastSubmittedGet(uid: string, isDailyWorkout?: boolean, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutLastSubmittedQueryResult>;
    public meUserWorkoutsUidLastSubmittedGet(uid: string, isDailyWorkout?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutLastSubmittedQueryResult>>;
    public meUserWorkoutsUidLastSubmittedGet(uid: string, isDailyWorkout?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutLastSubmittedQueryResult>>;
    public meUserWorkoutsUidLastSubmittedGet(uid: string, isDailyWorkout?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidLastSubmittedGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isDailyWorkout !== undefined && isDailyWorkout !== null) {
            queryParameters = queryParameters.set('isDailyWorkout', <any>isDailyWorkout);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutLastSubmittedQueryResult>('get',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}/LastSubmitted`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Unsubmits a tracked workout
     * Reverts a submitted workout back to pending status, clearing recorded values, workout comments, and exercise comments. Returns the cleared data for frontend repopulation.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUidUnsubmitPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<UnsubmitWorkoutCommandResult>;
    public meUserWorkoutsUidUnsubmitPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UnsubmitWorkoutCommandResult>>;
    public meUserWorkoutsUidUnsubmitPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UnsubmitWorkoutCommandResult>>;
    public meUserWorkoutsUidUnsubmitPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meUserWorkoutsUidUnsubmitPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UnsubmitWorkoutCommandResult>('post',`${this.basePath}/Me/UserWorkouts/${encodeURIComponent(String(uid))}/Unsubmit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets workout submission days
     * Returns the days when user submitted workouts for the specified period
     * @param startDateLocal 
     * @param endDateLocal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserWorkoutsUserWorkoutSubmissionsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutSubmissionsForCalendarQueryResult>;
    public meUserWorkoutsUserWorkoutSubmissionsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutSubmissionsForCalendarQueryResult>>;
    public meUserWorkoutsUserWorkoutSubmissionsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutSubmissionsForCalendarQueryResult>>;
    public meUserWorkoutsUserWorkoutSubmissionsGet(startDateLocal?: string, endDateLocal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutSubmissionsForCalendarQueryResult>('get',`${this.basePath}/Me/UserWorkouts/UserWorkoutSubmissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Assigns workout to a user
     * Assigns a workout to a user&#x27;s schedule
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'body', reportProgress?: boolean): Observable<AssignWorkoutCommandResult>;
    public userWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssignWorkoutCommandResult>>;
    public userWorkoutsAssignPost(body?: AssignWorkoutCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssignWorkoutCommandResult>>;
    public userWorkoutsAssignPost(body?: AssignWorkoutCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AssignWorkoutCommandResult>('post',`${this.basePath}/UserWorkouts/Assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Assigns program to a user
     * Assigns a complete program to a user&#x27;s schedule
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsAssignProgramPost(body?: AssignProgramCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsAssignProgramPost(body?: AssignProgramCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsAssignProgramPost(body?: AssignProgramCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsAssignProgramPost(body?: AssignProgramCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/UserWorkouts/AssignProgram`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Updates attributes of workout activity
     * Updates the attributes (sets, reps, weight, etc.) of a workout activity
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsAttributesPut(body?: UpdateUserWorkoutActivityAttributesCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsAttributesPut(body?: UpdateUserWorkoutActivityAttributesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsAttributesPut(body?: UpdateUserWorkoutActivityAttributesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsAttributesPut(body?: UpdateUserWorkoutActivityAttributesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/UserWorkouts/Attributes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets user workout program days/day
     * Returns the user&#x27;s workout program days/schedule for a specified period
     * @param clientUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserScheduleQueryResult>;
    public userWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserScheduleQueryResult>>;
    public userWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserScheduleQueryResult>>;
    public userWorkoutsGet(clientUid?: string, startDateLocal?: string, endDateLocal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserScheduleQueryResult>('get',`${this.basePath}/UserWorkouts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets single user workout details
     * Returns detailed information for a user&#x27;s workout on a specific day
     * @param userWorkoutUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsGetSingleDayGet(userWorkoutUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSingleUserScheduleDayQueryResult>;
    public userWorkoutsGetSingleDayGet(userWorkoutUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSingleUserScheduleDayQueryResult>>;
    public userWorkoutsGetSingleDayGet(userWorkoutUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSingleUserScheduleDayQueryResult>>;
    public userWorkoutsGetSingleDayGet(userWorkoutUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userWorkoutUid !== undefined && userWorkoutUid !== null) {
            queryParameters = queryParameters.set('UserWorkoutUid', <any>userWorkoutUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSingleUserScheduleDayQueryResult>('get',`${this.basePath}/UserWorkouts/GetSingleDay`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Reorders and moves workout activities
     * Updates the ordering of activities within a user&#x27;s workout
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsOrdinalReorderPut(body?: UpdateUserWorkoutActivityOrdinalsCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsOrdinalReorderPut(body?: UpdateUserWorkoutActivityOrdinalsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsOrdinalReorderPut(body?: UpdateUserWorkoutActivityOrdinalsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsOrdinalReorderPut(body?: UpdateUserWorkoutActivityOrdinalsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/UserWorkouts/OrdinalReorder`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Submits a client&#x27;s workout completion
     * Records completion for a client&#x27;s workout on their behalf. The handler resolves the target client from the user workout, so all side effects are attributed to the client.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsSubmitPost(body?: SubmitWorkoutCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/UserWorkouts/Submit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Cancels coach tracking of a client&#x27;s workout
     * Releases the coach-tracking soft lock without submitting the workout. Idempotent. Does not delete draft workouts.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidCancelTrackingPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUidCancelTrackingPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUidCancelTrackingPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUidCancelTrackingPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidCancelTrackingPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/CancelTracking`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets chat-friendly user workout details
     * Returns lightweight workout details optimized for chat message display
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidChatGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutForChatPortalQueryResult>;
    public userWorkoutsUidChatGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutForChatPortalQueryResult>>;
    public userWorkoutsUidChatGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutForChatPortalQueryResult>>;
    public userWorkoutsUidChatGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidChatGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutForChatPortalQueryResult>('get',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/Chat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Deletes assigned user workout
     * Removes the assigned workout from the user&#x27;s schedule
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets user workout day details
     * Returns complete workout details for the specified user workout UID
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserWorkoutDetailsQueryResult>;
    public userWorkoutsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserWorkoutDetailsQueryResult>>;
    public userWorkoutsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserWorkoutDetailsQueryResult>>;
    public userWorkoutsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserWorkoutDetailsQueryResult>('get',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Restores a client-dismissed user workout
     * Returns a workout the client removed back to Pending in their schedule
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidRestorePost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUidRestorePost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUidRestorePost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUidRestorePost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidRestorePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/Restore`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Starts coach editing of a client&#x27;s workout
     * Acquires the same soft lock as StartTracking but for restructuring the workout, so it also applies to completed and future-dated workouts. Blocks the client&#x27;s own submit/delete until the lock expires or is released. Released via CancelTracking.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidStartEditingPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<StartCoachTrackingCommandResult>;
    public userWorkoutsUidStartEditingPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StartCoachTrackingCommandResult>>;
    public userWorkoutsUidStartEditingPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StartCoachTrackingCommandResult>>;
    public userWorkoutsUidStartEditingPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidStartEditingPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StartCoachTrackingCommandResult>('post',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/StartEditing`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Starts coach tracking of a client&#x27;s workout
     * Acquires a soft lock so the coach can record completion. Blocks the client&#x27;s own submit until the lock expires or is released.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidStartTrackingPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<StartCoachTrackingCommandResult>;
    public userWorkoutsUidStartTrackingPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StartCoachTrackingCommandResult>>;
    public userWorkoutsUidStartTrackingPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StartCoachTrackingCommandResult>>;
    public userWorkoutsUidStartTrackingPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidStartTrackingPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StartCoachTrackingCommandResult>('post',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/StartTracking`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Unsubmits a client&#x27;s tracked workout
     * Reverts a client&#x27;s submitted workout back to pending status, clearing recorded values, workout comments and exercise comments.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUidUnsubmitPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<UnsubmitWorkoutCommandResult>;
    public userWorkoutsUidUnsubmitPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UnsubmitWorkoutCommandResult>>;
    public userWorkoutsUidUnsubmitPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UnsubmitWorkoutCommandResult>>;
    public userWorkoutsUidUnsubmitPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUidUnsubmitPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UnsubmitWorkoutCommandResult>('post',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(uid))}/Unsubmit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [SYSTEM] Updates workout statuses
     * System job that updates workout statuses based on date and completion
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUpdateStatusesPut(body?: UpdateWorkoutStatusesCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUpdateStatusesPut(body?: UpdateWorkoutStatusesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUpdateStatusesPut(body?: UpdateWorkoutStatusesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUpdateStatusesPut(body?: UpdateWorkoutStatusesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/UserWorkouts/UpdateStatuses`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Reorders and moves workouts in client scheduler
     * Updates the ordering and dates of workouts in a user&#x27;s schedule
     * @param userUid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUserUidPut(userUid: string, body?: UpdateUserScheduleCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUserUidPut(userUid: string, body?: UpdateUserScheduleCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUserUidPut(userUid: string, body?: UpdateUserScheduleCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUserUidPut(userUid: string, body?: UpdateUserScheduleCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userUid === null || userUid === undefined) {
            throw new Error('Required parameter userUid was null or undefined when calling userWorkoutsUserUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/UserWorkouts/${encodeURIComponent(String(userUid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Deletes user workout activity
     * Removes a specific activity from a user&#x27;s workout
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUserWorkoutActivityUidDelete(uid: string, body?: DeleteUserWorkoutActivityCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUserWorkoutActivityUidDelete(uid: string, body?: DeleteUserWorkoutActivityCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUserWorkoutActivityUidDelete(uid: string, body?: DeleteUserWorkoutActivityCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUserWorkoutActivityUidDelete(uid: string, body?: DeleteUserWorkoutActivityCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUserWorkoutActivityUidDelete.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/UserWorkouts/UserWorkoutActivity/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Updates user workout
     * Updates the details of a user&#x27;s assigned workout
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userWorkoutsUserWorkoutUidPut(uid: string, body?: UpdateUserWorkoutCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userWorkoutsUserWorkoutUidPut(uid: string, body?: UpdateUserWorkoutCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userWorkoutsUserWorkoutUidPut(uid: string, body?: UpdateUserWorkoutCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userWorkoutsUserWorkoutUidPut(uid: string, body?: UpdateUserWorkoutCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userWorkoutsUserWorkoutUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/UserWorkouts/UserWorkout/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
